import { Action, createReducer, on } from '@ngrx/store';

import * as GoogleAnalyticsActions from './google-analytics.actions';
import { GoogleAnalyticsConfiguration, GoogleAnalyticsEvent } from './google-analytics.models';

export const GOOGLE_ANALYTICS_FEATURE_KEY = 'googleAnalytics';

export interface GoogleAnalyticsState {
  initialized: boolean;
  previousUrl?: string;
  latestPageView?: GoogleAnalyticsEvent;
  configuration?: GoogleAnalyticsConfiguration;
}

export interface GoogleAnalyticsPartialState {
  readonly [GOOGLE_ANALYTICS_FEATURE_KEY]: GoogleAnalyticsState;
}

export const initialGoogleAnalyticsState: GoogleAnalyticsState = {
  initialized: false,
};

const reducer = createReducer(
  initialGoogleAnalyticsState,
  on(GoogleAnalyticsActions.initialize, (state, action) => ({
    ...state,
    configuration: action,
  })),
  on(GoogleAnalyticsActions.setPreviousUrl, (state, action) => ({
    ...state,
    previousUrl: action.url,
  })),
  on(GoogleAnalyticsActions.push, (state, action) => {
    if (action['event'] === 'pageview') {
      return {
        ...state,
        latestPageView: action,
      };
    }

    return state;
  })
);

export function googleAnalyticsReducer(state: GoogleAnalyticsState | undefined, action: Action) {
  return reducer(state, action);
}
